import React from 'react';
import { StarIcon } from 'lucide-react';
import { testimonials } from '../data/testimonials';
import { Mark, SectionTitle } from './ui/Section';
export function Testimonials() {
  return <section className="bg-slate-50 px-4 py-12 md:py-16" data-id="element-222" data-mp="3fze45yusr5w7">
      <div className="mx-auto max-w-6xl" data-id="element-223" data-mp="3fxuooagysyvh">
        <SectionTitle data-id="element-224" data-mp="3b147fjtfbx8h">
          What professionals <Mark data-id="element-225" data-mp="3b01g5as6vss1">are saying</Mark>
        </SectionTitle>

        <div className="mt-8 grid gap-5 md:grid-cols-2 lg:grid-cols-6" data-id="element-226" data-mp="36zin5dek8go9">
          {testimonials.map((item, index) => <figure key={item.name} className={`flex flex-col rounded-2xl border border-brand/10 bg-white p-6 shadow-sm lg:col-span-2 ${index === 3 ? 'lg:col-start-2' : ''}`} data-id="element-227" data-mp="31yuw4rqbzzu1" data-mpi={index}>
              <div className="flex gap-0.5" role="img" aria-label="5 out of 5 stars" data-id="element-228" data-mp="2s39r0kpyujg2">
                {Array.from({
              length: 5
            }).map((_, i) => <StarIcon key={i} className="h-4 w-4 fill-gold text-gold" aria-hidden="true" data-id="element-229" data-mp="qalj3y2dn7ty" data-mpi={i} />)}
              </div>
              <blockquote className="mt-4 flex-1 text-sm leading-relaxed text-brand-deep" data-id="element-230" data-mp="h4wyecfigumy">“{item.quote}”</blockquote>
              <figcaption className="mt-5 flex items-center gap-3 border-t border-brand/10 pt-4" data-id="element-231" data-mp="m6m7vnn3508x">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-brand text-xs font-black text-gold-light" data-id="element-232" data-mp="79bo7r0ago24">
                  {item.initials}
                </span>
                <span data-id="element-233" data-mp="zwxz7kbuiuz0">
                  <span className="block text-sm font-extrabold uppercase text-brand-deep" data-id="element-234" data-mp="zyscqdksfkt2">{item.name}</span>
                  <span className="block text-xs text-slate-600" data-id="element-235" data-mp="q6mn3ai0dfh1">{item.role}</span>
                </span>
              </figcaption>
            </figure>)}
        </div>
        <p className="mt-6 text-center text-xs text-slate-600" data-id="element-236" data-mp="v3msdj71ae73">Individual experiences may vary.</p>
      </div>
    </section>;
}